import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Button, ButtonType } from '@nhl/nhl-breakaway-ui';

import { reportActionCreators } from '~/redux/ducks/playersAndTeams/report';
import { areObjectsDifferent } from '~/redux/ducks/playersAndTeams/sagas/runReportValidation';
import Analytics from '~/utility/analytics';
import { commonMessages } from '~/utility/commonMessages';

const SubmitButton = ({ handleClose }) => {
    const dispatch = useDispatch();

    const statsConfig = useSelector(({ config }) => config);
    const filterState = useSelector(({ playersAndTeams }) => playersAndTeams.filter);
    const playersAndTeamsReport = useSelector(({ playersAndTeams }) => playersAndTeams.report);
    const appliedReportState = playersAndTeamsReport.applied;
    const currentReportState = playersAndTeamsReport.current;

    const reportFiltersChanged = areObjectsDifferent(currentReportState, appliedReportState);
    const advancedFiltersChanged = areObjectsDifferent(filterState.values, filterState.applied);
    const isDisabled = !reportFiltersChanged && !advancedFiltersChanged;

    const handleClick = () => {
        Analytics.sendGaReportEvent('get-stats', currentReportState, filterState.values, statsConfig.franchiseData);
        dispatch(reportActionCreators.runReport());
        handleClose();
    };

    return (
        <Button type="submit" variant={ButtonType.CTA} disabled={isDisabled} onClick={handleClick}>
            <FormattedMessage {...commonMessages.labels.applyFilters} />
        </Button>
    );
};

export default SubmitButton;
